import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const productOpportunitiesAnalysisSlice = createApi({
  reducerPath: "analysis_opportunities",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["product_opportunities"],
  endpoints: (build) => ({
    getProductOpportunitiesSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=product_opportunities&view=summary&page=0&size=10`,
        url:`/bank/${orgId}/dashboard/${payload.requid}/product_opportunities/summary`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),

    getProductOpportunitiesExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=product_opportunities&view=expand&page=0&size=10`,
        url:`/bank/${orgId}/dashboard/${payload.requid}/product_opportunities/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetProductOpportunitiesSummaryQuery,
  useGetProductOpportunitiesExpandedQuery,
} = productOpportunitiesAnalysisSlice;
